{
	"optionsOrders": {
		"activeOrders": {
			"filled": "Исполненные",
			"open": "Открытые",
			"canceled": "Отмененные",
			"OPEXP": "Истёк",
			"OPEXC": "Исполнен",
			"OPASN": "Рассчитан"
		},
		"optionsType": {
			"orders": "Ордера",
			"postTrading": "Пост-трейдинг"
		}
	}
}
